import { useMediaQuery, useDebouncedValue } from "@mantine/hooks";
import { Button, Loader, Modal, Tabs, TextInput, Pagination, Popover, Stack, Paper } from "@mantine/core";
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import "../components/customer/orders/PlaceOrdersDetails.css"
import { useLocation, useNavigate } from "react-router-dom";
import _, { filter } from "lodash";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment/moment";
import Navigation from "../components/customer/sidebar/Navigation";
import { createB2BAPI } from "../api/Interceptor";
import { BASE_URL } from "../api/EndPoints";
import PaymentDetailPage from "../components/customer/orders/PaymentDetailPage";
import notify from "../utils/Notification";
import B2BTableGrid from "../components/common/B2BTableGrid";
import { IconEdit, IconPencil, IconPlus, IconSearch } from "@tabler/icons-react";
import { Grid, Input } from "@mantine/core";
import { DateInput } from "@mantine/dates";
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import ProductsCell from "./ProductsCell";
import "./product/VendorStockAvailability.css";
import { useLoader } from "../Context/LoaderContext";
const initialTransaction = {
    bankName: "",
    utrNo: "",
    depositAmount: "",
    dateOfDeposit: null,
    customerOrderNo: "",
};

const Approved = ({ activeTabTopFromBack, orderType = "WHOLESALE" }) => {
    const isMobile = useMediaQuery("(max-width: 767px)");
    const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 991px)");
    const { showLoader, hideLoader } = useLoader();
    const location = useLocation();
    const userId = JSON.parse(localStorage.getItem('user'))?.userId;
    const selectedStatusTypeFromBack = location.state?.selectedStatusTypeFromBack
    const [selectedStatusType, setSelectedStatusType] = useState(selectedStatusTypeFromBack ? selectedStatusTypeFromBack : 'NEW')
    const [orders, setOrders] = useState([]);
    const [selectedAsns, setSelectedAsns] = useState([]);
    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]); const [showToast, setShowToast] = useState(false);
    const [relord, setReload] = useState(true)
    const [isLrModalOpen, setIsLrModalOpen] = useState(false);

    const [lrFormData, setLrFormData] = useState({
        transporterName: "",
        logesticReciptNo: "",
        lrReceiptDate: null,
        containerNumber: "",
        cartonNumber: "",
        ewayBillNo: "",
        vehicleNo: "",
        documentNo: "",
        trackingId: "",
        mobileNo: "",
        deliveryDate: null,
        shipmentDate: null,
        lrDocument: null,
    });
    const handleCloseLrModal = () => {
        setLrFormData({});
        setIsLrModalOpen(false);
    };
    const isLrFormValid = lrFormData.transporterName && lrFormData.logesticReciptNo && lrFormData.lrReceiptDate && (orderType === "WHOLESALE" || lrFormData.cartonNumber);

    const handleLrSubmit = async () => {
        try {
            const { lrDocument, ...shipmentWithoutFile } = lrFormData;
            const formDataPayload = new FormData();
            if (lrDocument instanceof File) {
                formDataPayload.append("lrDocument", lrDocument);
            }
            const mergedAsnNo = selectedAsns.join(",");
            formDataPayload.append(
                "shipment",
                new Blob(
                    [JSON.stringify({
                        ...shipmentWithoutFile,
                        asnNo: selectedAsns[0],
                        asnNos: selectedAsns
                    })],
                    { type: "application/json" }
                )
            );
            console.log(formDataPayload, "mlml")
            await B2B_API.post(`asn/updateAsn`, { body: formDataPayload }).json();

            notify({
                error: false,
                success: true,
                title: "Logistics details saved and ASNs merged successfully",
            });

            setIsLrModalOpen(false);
            setLrFormData({
                transporterName: "",
                logesticReciptNo: "",
                lrReceiptDate: null,
                containerNumber: "",
                cartonNumber: "",
                ewayBillNo: "",
                vehicleNo: "",
                documentNo: "",
                trackingId: "",
                mobileNo: "",
                deliveryDate: null,
                shipmentDate: null,
                lrDocument: null,
            });
            setSelectedAsns([]);
            fetchOrders();
            fetchAllOrdersForCounts();
        } catch (error) {
            console.error("Error saving logistics details:", error);
            notify({
                error: true,
                success: false,
                title: error?.response?.data?.message || "Failed to save logistics details",
            });
        }
    };
    const variantOptions = useMemo(() => {
        const options = [
            "PO",
            "ASN",
            "GE",
            "GRN",
            // "INVOICE"
        ];
        return options;
    }, [orderType]);
    const [activeTab, setActiveTab] = useState(
        activeTabTopFromBack ? activeTabTopFromBack : variantOptions[0]
    );
    const [activeCancelOrder, setActiveCancelOrder] = useState(null);
    const [groupList, setGrouplist] = useState({});
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [paymentOpened, setPaymentOpened] = useState(false);
    const [allOrdersByStatus, setAllOrdersByStatus] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [salesOrder, setSalesOrder] = useState({
        paymentHistory: {},
    });
    const [orderSearch, setOrderSearch] = useState({
        fromDate: null,
        toDate: new Date(),
        search: ""
    });
    const [debouncedOrderSearch] = useDebouncedValue(orderSearch, 500);
    const [order, setOrder] = useState([]);
    const [filteredOrderType, SetFilteredOrderType] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
    console.log(selectedStatusType, "mkmkmk")
    // useEffect(() => {
    //     fetchOrders();
    // }, [filteredOrderType]);
    useEffect(() => {
        fetchOrders();
        fetchAllOrdersForCounts();
    }, [pagination?.pageIndex, pagination?.pageSize, debouncedOrderSearch, activeTab, selectedStatusType, orderType]);
    useEffect(() => {
        if (location?.state?.activeTabFromLocation) {
            setActiveTab(location?.state?.activeTabFromLocation);
        }
    }, [location]);

    useEffect(() => {
        setPage(0)
        setGrouplist({})
        setOrders([]);
        setSelectedAsns([]);
        setOrderSearch({
            fromDate: null,
            toDate: new Date(),
            search: ""
        });
        if (activeTab === "PO") {
            setSelectedStatusType("PENDING");
        } else {
            setSelectedStatusType("NEW");
        }
        setReload(prev => !prev)
    }, [orderType, activeTab,]);

    const counts = useMemo(() => {
        return ["NEW", "PENDING", "CONFIRMED", "REJECTED"].reduce((acc, status) => {
            acc[status] = allOrdersByStatus?.[status] || 0;
            return acc;
        }, {});
    }, [allOrdersByStatus, selectedStatusType]);

    const fetchAllOrdersForCounts = async () => {
        const statuses = ["NEW", "PENDING", "CONFIRMED", "REJECTED"];
        const allOrders = {};
        try {
            for (const status of statuses) {
                let mappedStatus = status;
                let url = "";

                if (activeTab === "PO") {
                    if (status === "PENDING") {
                        mappedStatus = "PENDING";
                        url = `purchase-order/unApproved/search?page=0&pageSize=1&orderType=${orderType}&vendorId=${userId}`;
                    } else if (status === "REJECTED") {
                        mappedStatus = "REJECTED";
                        url = `purchase-order/rejected/search?page=0&pageSize=1&orderType=${orderType}&vendorId=${userId}`;
                    } else {
                        mappedStatus = status === "NEW" ? "NEW" : "CONFIRMED";
                        url = `purchase-order/search?page=0&pageSize=1&orderType=${orderType}`;
                    }
                } else if (activeTab === "ASN") {
                    if (status === "NEW") {
                        mappedStatus = "PENDING_ASN";
                        url = `purchase-order/search?page=0&pageSize=1&orderType=${orderType}`;
                    } else if (status === "PENDING") {
                        mappedStatus = "PENDING";
                        url = `asn/search?page=0&pageSize=1&orderType=${orderType}`;
                    } else if (status === "CONFIRMED") {
                        mappedStatus = "CONFIRMED";
                        url = `asn/search?page=0&pageSize=1&orderType=${orderType}`;
                    }
                } else if (activeTab === "GE") {
                    mappedStatus = status === "NEW" ? "PENDING_GE" : "COMPLETED_GE";
                    url = `asn/search?page=0&pageSize=1&orderType=${orderType}`;
                }
                else if (activeTab === "GRN") {
                    mappedStatus = status === "NEW" ? "PENDING_GRN" : "COMPLETED_GRN";
                    url = `asn/search?page=0&pageSize=1&orderType=${orderType}`;
                }
                const searchOrder = {
                    ...debouncedOrderSearch,
                    status: mappedStatus,
                    orderType,
                    fromDate: _.isDate(debouncedOrderSearch.fromDate)
                        ? moment(debouncedOrderSearch.fromDate).format("DD/MM/YYYY")
                        : null,
                    toDate: _.isDate(debouncedOrderSearch.toDate)
                        ? moment(debouncedOrderSearch.toDate).format("DD/MM/YYYY")
                        : null,
                };

                const response = await B2B_API.post(url, { json: searchOrder }).json();
                allOrders[status] = response?.response?.totalElements || 0;
            }
        } catch (error) {
            console.error("Error fetching counts:", error);
        }

        setAllOrdersByStatus(allOrders);
    };


    const handleTabChange = (option) => {
        setActiveTab(option);
    };
    useEffect(() => {
        setPagination({ pageIndex: 0, pageSize: 5 });
        setSelectedAsns([]);
    }, [activeTab, selectedStatusType]);
    const handleClickOutside = (event) => {
        if (event.target.classList.contains("modal-backdrop")) {
            setActiveCancelOrder(null);
        }
    };

    useEffect(() => {
        if (activeCancelOrder) {
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("click", handleClickOutside);
        }
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [activeCancelOrder]);


    const paymentClose = () => {
        setPaymentOpened(false);
        setSalesOrder({ payment: {} });
    };

    const columns = useMemo(() => [
        {
            header: 'PO Date',
            accessorKey: 'createdDate',
            size: 120,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            accessorFn: row => moment(row?.createdDate).format('DD/MM/YYYY')
        },
        {
            header: 'PO No',
            accessorKey: 'poId',
            size: 150,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            cell: ({ row }) => {
                const data = row.original;

                const poList = data?.groupedPoIds
                    ? data.groupedPoIds.split(',')
                    : data?.poId
                        ? [data.poId]
                        : [];

                const isMulti = poList.length > 1;
                const isWholesale = data?.orderType === 'WHOLESALE';

                const mtoEnquiryIds = data?.mtoEnquiryIds;
                const linkedPoId = data?.linkedPoId;

                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>

                            {/* SINGLE PO */}
                            {!isMulti ? (
                                <div style={{ fontSize: 13 }}>
                                    {poList[0] || '-'}
                                </div>
                            ) : (
                                <Popover position="bottom" withArrow shadow="xl">
                                    <Popover.Target>
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                fontSize: 13,
                                                textAlign: 'center',
                                            }}
                                        >
                                            {poList.length} POs
                                        </div>
                                    </Popover.Target>

                                    <Popover.Dropdown p={6} style={{ width: 'fit-content' }}>
                                        <div
                                            style={{
                                                fontSize: 12,
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {poList.join(', ')}
                                        </div>
                                    </Popover.Dropdown>
                                </Popover>
                            )}

                            {isWholesale
                                ? (mtoEnquiryIds?.length > 0 && (
                                    <div style={{ fontSize: '10px', color: 'green' }}>
                                        REF EQ : {mtoEnquiryIds.join(', ')}
                                    </div>
                                ))
                                : (linkedPoId && (
                                    <div style={{ fontSize: '10px', color: 'green' }}>
                                        REF PO : {linkedPoId}
                                    </div>
                                ))
                            }

                        </div>
                    </div>
                );
            }
        },
        ...(activeTab === 'GE' || (activeTab === 'ASN' && selectedStatusType !== 'NEW') || activeTab === 'GRN'
            ? [{
                header: 'ASN No',
                size: 160,
                mantineTableHeadCellProps: { align: 'center' },
                mantineTableBodyCellProps: { align: 'center' },
                cell: ({ row }) => {
                    const data = row.original;

                    const asnList = data?.groupedAsnNos
                        ? data.groupedAsnNos.split(',')
                        : data?.asnNo
                            ? [data.asnNo]
                            : [];

                    const isMulti = asnList.length > 1;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>

                                {/* SINGLE ASN → NORMAL TEXT */}
                                {!isMulti ? (
                                    <div
                                        style={{
                                            fontSize: 13,
                                        }}
                                    >
                                        {asnList[0] || '-'}
                                    </div>
                                ) : (
                                    /* MULTIPLE ASN → POPUP */
                                    <Popover position="bottom" withArrow shadow="xl">
                                        <Popover.Target>
                                            <div
                                                style={{
                                                    cursor: 'pointer',
                                                    fontSize: 13,
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {asnList.length} ASNs
                                            </div>
                                        </Popover.Target>

                                        <Popover.Dropdown p={6} style={{ width: 'fit-content' }}>
                                            <div
                                                style={{
                                                    fontSize: 12,
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {asnList.join(', ')}
                                            </div>
                                        </Popover.Dropdown>
                                    </Popover>
                                )}

                                {data?.multiLrNo && (
                                    <div
                                        style={{
                                            fontSize: 10,
                                            color: '#2f9e44',
                                        }}
                                    >
                                        {data.multiLrNo}
                                    </div>
                                )}

                                {data?.mergedIntoAsnNo && (
                                    <div
                                        style={{
                                            fontSize: 10,
                                            color: '#868e96',
                                            background: '#f1f3f5',
                                            padding: '2px 8px',
                                            borderRadius: 12
                                        }}
                                    >
                                        Merged → {data.mergedIntoAsnNo}
                                    </div>
                                )}

                            </div>
                        </div>
                    );
                }
            }]
            : []),

        ...(activeTab === 'GE' && selectedStatusType !== 'NEW' || activeTab === 'GRN'
            ? [
                {
                    header: 'GE No',
                    size: 100,
                    mantineTableHeadCellProps: { align: 'center' },
                    mantineTableBodyCellProps: { align: 'center' },
                    accessorFn: row => row?.ge?.geNo ? `${row?.ge?.geNo}` : '-',
                },
            ]
            : []),
        ...(activeTab === 'GRN' && selectedStatusType !== 'NEW'
            ? [
                {
                    header: 'GRN No',
                    size: 100,
                    mantineTableHeadCellProps: { align: 'center' },
                    mantineTableBodyCellProps: { align: 'center' },
                    accessorFn: row => row?.grnNo ? `${row?.grnNo}` : '-',
                },
            ]
            : []),
        {
            header: 'PO Type',
            accessorKey: 'orderType',
            size: 100,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
        },
        // {
        //     header: 'Vendor',
        //     accessorKey: 'vendor.supplier',
        //     size: 150,
        //     mantineTableHeadCellProps: { align: 'center' },
        //     mantineTableBodyCellProps: { align: 'center' }
        // },
        {
            header: 'Products',
            size: 100,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            cell: ({ row }) => <ProductsCell row={row?.original} />
        },
        {
            header: 'Ship to',
            accessorFn: row => row?.shipLocation ? ` ${row?.shipLocation?.name}, ${row?.shipLocation?.city}, ${row?.shipLocation?.state}` : 'N/A',
            size: 150,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' }
        },
        {
            header: 'Total Amount',
            size: 100,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            accessorFn: row => row?.grossTotal ? `₹ ${row?.grossTotal}` : '₹ 0.00',
        },
        {
            header: 'Merchandiser',
            size: 100,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            accessorFn: row => row?.vendor?.buyerName ? `${row?.vendor?.buyerName}` : 'N/A',
        },
        // {
        //     header: 'Payment Status',
        //     size: 100,
        //     mantineTableHeadCellProps: { align: 'center' },
        //     mantineTableBodyCellProps: { align: 'center' },
        //     accessorFn: row => row?.grossTotal?.nk ? `${row?.grossTotal?.mk}` : 'N/A',
        // },

        {
            header: 'Action',
            accessorKey: 'orderStatus',
            size: 120,
            mantineTableHeadCellProps: { align: 'center' },
            mantineTableBodyCellProps: { align: 'center' },
            enableSorting: false,
            enableColumnDragging: false,
            cell: ({ row }) => {
                let backgroundColor;

                switch (row?.original?.orderStatus?.toUpperCase()) {
                    case 'PENDING ALLOCATION':
                        backgroundColor = 'red';
                        break;
                    case 'PART ALLOCATED':
                        backgroundColor = 'orange';
                        break;
                    case 'ALLOCATED':
                        backgroundColor = '#4CAF50';
                        break;
                    default:
                        backgroundColor = 'gray';
                }
                return (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <IconEdit size={18}
                            onClick={() => {
                                navigate(`/purchase/po-view`, {
                                    state: { poId: row?.original?.poId, asnId: row?.original?.asnNo, activeHeader: activeTab, selectedStatusType: selectedStatusType, orderType: orderType },
                                });
                            }}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            }

        },
        ...(activeTab === 'ASN' && selectedStatusType === 'PENDING'
            ? [
                {
                    id: 'select',
                    header: 'Select',
                    cell: ({ row }) => (
                        <input
                            type="checkbox"
                            style={{
                                width: '18px',
                                height: '18px',
                                cursor: 'pointer',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                                borderRadius: '8px'
                            }}
                            checked={selectedAsns.includes(row.original.asnNo)}
                            onClick={(e) => e.stopPropagation()}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedAsns(prev => [...prev, row.original.asnNo]);
                                } else {
                                    setSelectedAsns(prev => prev.filter(no => no !== row.original.asnNo));
                                }
                            }}
                        />
                    ),
                    size: 50,
                }
            ]
            : []),
    ], [activeTab, orderType, orderSearch?.search, orderSearch?.fromDate, orderSearch?.toDate, pagination.pageIndex, pagination.pageSize, selectedStatusType, selectedAsns, filteredOrderType]);

    const fetchOrders = async () => {
        setIsLoading(true);
        showLoader();
        try {
            let mappedStatus = selectedStatusType;
            let url = "";

            if (activeTab === "PO") {
                if (selectedStatusType === "PENDING") {
                    mappedStatus = "PENDING";
                    url = `purchase-order/unApproved/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}&vendorId=${userId}`;
                } else if (selectedStatusType === "REJECTED") {
                    mappedStatus = "REJECTED";
                    url = `purchase-order/rejected/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}&vendorId=${userId}`;
                } else {
                    mappedStatus = selectedStatusType === "NEW" ? "NEW" : "CONFIRMED";
                    url = `purchase-order/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}`;
                }
            } else if (activeTab === "ASN") {
                if (selectedStatusType === "NEW") {
                    mappedStatus = "PENDING_ASN";
                    url = `purchase-order/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}`;
                } else if (selectedStatusType === "PENDING") {
                    mappedStatus = "PENDING";
                    url = `asn/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}`;
                } else if (selectedStatusType === "CONFIRMED") {
                    mappedStatus = "CONFIRMED";
                    url = `asn/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}`;
                }
            } else if (activeTab === "GE") {
                mappedStatus = selectedStatusType === "NEW" ? "PENDING_GE" : "COMPLETED_GE";
                url = `asn/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}`;
            }
            else if (activeTab === "GRN") {
                mappedStatus = selectedStatusType === "NEW" ? "PENDING_GRN" : "COMPLETED_GRN";
                url = `asn/search?page=${pagination.pageIndex}&pageSize=${pagination.pageSize}&orderType=${orderType}`;
            }

            const searchOrder = {
                ...debouncedOrderSearch,
                status: mappedStatus,
                orderType,
                fromDate: _.isDate(debouncedOrderSearch.fromDate)
                    ? moment(debouncedOrderSearch.fromDate).format("DD/MM/YYYY")
                    : null,
                toDate: _.isDate(debouncedOrderSearch.toDate)
                    ? moment(debouncedOrderSearch.toDate).format("DD/MM/YYYY")
                    : null,
            };

            const response = await B2B_API.post(url, { json: searchOrder }).json();
            let data = response.response.content;

            setRowCount(response.response.totalElements);

            // Grouping logic for Multi LR
            const groupedMap = {};
            const finalData = [];

            data.forEach(item => {
                if (item.multiLrNo) {
                    if (!groupedMap[item.multiLrNo]) {
                        groupedMap[item.multiLrNo] = {
                            ...item,
                            groupedAsnNos: item.groupedAsnNos || item.asnNo,
                            groupedPoIds: item.groupedPoIds || item.poId
                        };
                        finalData.push(groupedMap[item.multiLrNo]);
                    } else {
                        const group = groupedMap[item.multiLrNo];
                        if (item.asnNo && !group.groupedAsnNos.includes(item.asnNo)) {
                            group.groupedAsnNos += ", " + item.asnNo;
                        }
                        if (item.poId && !group.groupedPoIds.includes(item.poId)) {
                            group.groupedPoIds += ", " + item.poId;
                        }
                        if (!item.mergedIntoAsnNo) {
                            group.grossTotal = item.grossTotal;
                            group.asnNo = item.asnNo;
                        }
                    }
                } else {
                    finalData.push(item);
                }
            });

            data = finalData;

            const wholesaleOrders = data.filter((item) => item?.orderType === "WHOLESALE");
            const sampleOrders = data.filter((item) => item?.orderType === "SAMPLE");
            const swatchOrders = data.filter((item) => item?.orderType === "SWATCH");

            const PotypeOrders =
                orderType === "SAMPLE"
                    ? sampleOrders
                    : orderType === "WHOLESALE"
                        ? wholesaleOrders
                        : orderType === "SWATCH"
                            ? swatchOrders
                            : data;

            setOrder(data);
            SetFilteredOrderType(PotypeOrders);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
            hideLoader();
        }
    };


    const handleOrderSearch = (value, key) => {
        setOrderSearch(prev => ({ ...prev, [key]: value }))
    }

    const totalPages = Math.ceil(rowCount / pagination.pageSize);

    const renderMobileCards = () => {
        if (isLoading) return <div style={{ textAlign: "center", padding: "2rem" }}>Loading...</div>;
        if (!filteredOrderType || filteredOrderType.length === 0) return <div style={{ textAlign: "center", padding: "2rem", color: "#666" }}>No data found.</div>;

        return (
            <div className="vsa-mobile-cards">
                {filteredOrderType.map((item, index) => {
                    let backgroundColor;
                    switch (item?.orderStatus?.toUpperCase()) {
                        case 'PENDING ALLOCATION': backgroundColor = 'red'; break;
                        case 'PART ALLOCATED': backgroundColor = 'orange'; break;
                        case 'ALLOCATED': backgroundColor = '#4CAF50'; break;
                        default: backgroundColor = 'gray';
                    }

                    return (
                        <div key={index} className="vsa-card">
                            <div className="vsa-card-header">
                                <span className="vsa-card-date">{moment(item?.createdDate).format("DD/MM/YYYY")}</span>
                                <span style={{ fontSize: "0.85rem", fontWeight: "bold", color: backgroundColor }}>
                                    {activeTab === "PO" && selectedStatusType === "NEW" ? "PO New" :
                                        activeTab === "PO" && selectedStatusType === "CONFIRMED" ? "PO Completed" :
                                            activeTab === "PO" && selectedStatusType === "REJECTED" ? "PO Rejected" :
                                                activeTab === "ASN" && selectedStatusType === "NEW" ? "ASN Pending" :
                                                    activeTab === "ASN" && selectedStatusType === "PENDING" ? "LR Pending" :
                                                        activeTab === "ASN" && selectedStatusType === "CONFIRMED" ? "ASN Completed" :
                                                            activeTab === "GE" && selectedStatusType === "NEW" ? "GE Pending" :
                                                                activeTab === "GE" && selectedStatusType === "CONFIRMED" ? "GE Completed" :
                                                                    activeTab === "GRN" && selectedStatusType === "NEW" ? "GRN Pending" :
                                                                        activeTab === "GRN" && selectedStatusType === "CONFIRMED" ? "GRN Completed" : ""}
                                </span>
                            </div>
                            <div className="vsa-card-body">
                                <div className="vsa-card-row">
                                    <span className="vsa-card-label">PO No:</span>
                                    <span className="vsa-card-value">{item?.groupedPoIds || item?.poId}</span>
                                </div>
                                {(((activeTab === 'GE' || activeTab === 'ASN') && selectedStatusType !== 'NEW') || activeTab === 'GRN') && (
                                    <div className="vsa-card-row">
                                        <span className="vsa-card-label">ASN No:</span>
                                        <span className="vsa-card-value">
                                            {item?.groupedAsnNos || item?.asnNo || '-'}
                                            {item?.multiLrNo && (
                                                <div style={{ fontSize: '12px', color: '#8BC53F', marginTop: '4px' }}>
                                                    Group: {item.multiLrNo}
                                                </div>
                                            )}
                                        </span>
                                    </div>
                                )}
                                {((activeTab === 'GE' && selectedStatusType !== 'NEW') || activeTab === 'GRN') && (
                                    <div className="vsa-card-row">
                                        <span className="vsa-card-label">GE No:</span>
                                        <span className="vsa-card-value">{item?.ge?.geNo || '-'}</span>
                                    </div>
                                )}
                                {(activeTab === 'GRN' && selectedStatusType !== 'NEW') && (
                                    <div className="vsa-card-row">
                                        <span className="vsa-card-label">GRN No:</span>
                                        <span className="vsa-card-value">{item?.grnNo || '-'}</span>
                                    </div>
                                )}
                                <div className="vsa-card-row">
                                    <span className="vsa-card-label">PO Type:</span>
                                    <span className="vsa-card-value">{item?.orderType}</span>
                                </div>
                                <div className="vsa-card-row" style={{ alignItems: "flex-start" }}>
                                    <span className="vsa-card-label">Products:</span>
                                    <span className="vsa-card-value"><ProductsCell row={item} /></span>
                                </div>
                                <div className="vsa-card-row">
                                    <span className="vsa-card-label">Ship to:</span>
                                    <span className="vsa-card-value">{item?.shipLocation ? `${item?.shipLocation?.name}, ${item?.shipLocation?.city}, ${item?.shipLocation?.state}` : 'N/A'}</span>
                                </div>
                                <div className="vsa-card-row">
                                    <span className="vsa-card-label">Total Amount:</span>
                                    <span className="vsa-card-value">{item?.grossTotal ? `₹ ${item?.grossTotal}` : '₹ 0.00'}</span>
                                </div>
                                <div className="vsa-card-row">
                                    <span className="vsa-card-label">Merchandiser:</span>
                                    <span className="vsa-card-value">{item?.vendor?.buyerName || 'N/A'}</span>
                                </div>
                            </div>
                            <div className="vsa-card-actions">
                                <Button
                                    size="xs"
                                    variant="light"
                                    color="#8BC53F"
                                    leftSection={<IconPencil size={14} />}
                                    onClick={() => {
                                        navigate(`/purchase/po-view`, {
                                            state: { poId: item?.poId, asnId: item?.asnNo, activeHeader: activeTab, selectedStatusType: selectedStatusType, orderType: orderType },
                                        });
                                    }}
                                >
                                    Edit
                                </Button>
                            </div>
                        </div>
                    );
                })}
                {totalPages > 1 && (
                    <div className="vsa-pagination-mobile">
                        <Pagination
                            total={totalPages}
                            value={pagination.pageIndex + 1}
                            onChange={(page) => setPagination(p => ({ ...p, pageIndex: page - 1 }))}
                            color="#8BC53F"
                        />
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="view-my-page router-view-container">
            <div className="route-view">
                {!isMobile && !isTablet && <Navigation />}

                <div>
                    <Modal
                        opened={paymentOpened}
                        onClose={paymentClose}
                        centered
                        title="Payment Details"
                        size="lg"
                    >
                        <PaymentDetailPage
                            salesOrder={salesOrder}
                            setSalesOrder={setSalesOrder}
                            customerId={salesOrder?.customerId}
                        />

                        <div
                            style={{
                                marginTop: "2rem",
                                display: "flex",
                                gap: "1rem",
                                justifyContent: "center",
                            }}
                        >
                            <Button color="red" onClick={paymentClose}>
                                Cancel
                            </Button>
                        </div>
                    </Modal>
                </div>

                <Tabs
                    value={activeTab}
                    onChange={(e) => {
                        setActiveTab(e);
                        setHasMore(true);
                        setGrouplist({});
                        setPage(0);
                        setReload(prev => !prev)
                    }}
                >
                    <Tabs.List
                        styles={{

                            list: {
                                flexWrap: "nowrap",
                                overflowX: 'auto',
                                whiteSpace: 'nowrap',
                                scrollbarWidth: 'none',

                            },
                        }}
                    >
                        {variantOptions?.map((item) => (
                            <Tabs.Tab
                                key={item}
                                value={item}
                                onClick={() => handleTabChange(item)}
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <span>{item}</span>
                                </div>
                            </Tabs.Tab>
                        ))}
                    </Tabs.List>
                    <Tabs.Panel value={activeTab}>
                        <h2 style={{ marginTop: '1rem', marginBottom: '0.5rem', marginLeft: "1rem", fontWeight: 'bold', fontSize: "24px" }}>{activeTab === "PO" ? "Purchase Order" : activeTab === "ASN" ? "Advance Shippment Note" : activeTab === "GE" ? "Gate Entry" : activeTab === "GRN" ? "Goods Received Note" : ""} </h2>
                        <Tabs
                            value={selectedStatusType}
                            onChange={setSelectedStatusType}
                            variant="default"
                        >
                            <Tabs.List style={{ width: "100%" }}>
                                {activeTab === "PO" && <Tabs.Tab value="PENDING">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>PO Pending</span>
                                        <span
                                            className="tab-count"
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minWidth: "18px",
                                                height: "18px",
                                                borderRadius: "9px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                padding: "0 4px",
                                                marginLeft: "6px",
                                                verticalAlign: "middle",
                                                backgroundColor: selectedStatusType === "PENDING" ? "white" : "#8BC53F",
                                                color: selectedStatusType === "PENDING" ? "#8BC53F" : "white",
                                                boxShadow: selectedStatusType === "PENDING" ? "0 0 0 1px #8BC53F" : "none",
                                            }}
                                        >
                                            {counts?.PENDING ?? 0}
                                        </span>
                                    </div>
                                </Tabs.Tab>}
                                <Tabs.Tab value="NEW">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>
                                            {activeTab === "ASN" ? "ASN Pending" : activeTab === "GE" ? "GE Pending" : activeTab === "PO" ? "PO New" : activeTab === "GRN" ? "GRN New" : ""}
                                        </span>
                                        <span
                                            className="tab-count"
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minWidth: "18px",
                                                height: "18px",
                                                borderRadius: "9px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                padding: "0 4px",
                                                marginLeft: "6px",
                                                verticalAlign: "middle",
                                                backgroundColor: selectedStatusType === "NEW" ? "white" : "#8BC53F",
                                                color: selectedStatusType === "NEW" ? "#8BC53F" : "white",
                                                boxShadow: selectedStatusType === "NEW" ? "0 0 0 1px #8BC53F" : "none",
                                            }}
                                        >
                                            {counts?.NEW ?? 0}
                                        </span>
                                    </div>
                                </Tabs.Tab>
                                {activeTab === "ASN" && <Tabs.Tab value="PENDING">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>
                                            LR Pending
                                        </span>
                                        <span
                                            className="tab-count"
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minWidth: "18px",
                                                height: "18px",
                                                borderRadius: "9px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                padding: "0 4px",
                                                marginLeft: "6px",
                                                verticalAlign: "middle",
                                                backgroundColor: selectedStatusType === "NEW" ? "white" : "#8BC53F",
                                                color: selectedStatusType === "NEW" ? "#8BC53F" : "white",
                                                boxShadow: selectedStatusType === "NEW" ? "0 0 0 1px #8BC53F" : "none",
                                            }}
                                        >
                                            {counts?.PENDING ?? 0}
                                        </span>
                                    </div>
                                </Tabs.Tab>}

                                <Tabs.Tab value="CONFIRMED">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>
                                            {activeTab === "ASN" ? "ASN Completed" : activeTab === "GE" ? "GE Completed" : activeTab === "PO" ? "PO Completed" : activeTab === "GRN" ? "GRN Completed" : ""}
                                        </span>
                                        <span
                                            className="tab-count"
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minWidth: "18px",
                                                height: "18px",
                                                borderRadius: "9px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                padding: "0 4px",
                                                marginLeft: "6px",
                                                verticalAlign: "middle",
                                                backgroundColor: selectedStatusType === "CONFIRMED" ? "white" : "#8BC53F",
                                                color: selectedStatusType === "CONFIRMED" ? "#8BC53F" : "white",
                                                boxShadow: selectedStatusType === "CONFIRMED" ? "0 0 0 1px #8BC53F" : "none",
                                            }}
                                        >
                                            {counts?.CONFIRMED ?? 0}
                                        </span>
                                    </div>
                                </Tabs.Tab>
                                {activeTab === "PO" && <Tabs.Tab value="REJECTED">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <span>PO Rejected</span>
                                        <span
                                            className="tab-count"
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minWidth: "18px",
                                                height: "18px",
                                                borderRadius: "9px",
                                                fontSize: "12px",
                                                fontWeight: "bold",
                                                padding: "0 4px",
                                                marginLeft: "6px",
                                                verticalAlign: "middle",
                                                backgroundColor: selectedStatusType === "REJECTED" ? "white" : "#8BC53F",
                                                color: selectedStatusType === "REJECTED" ? "#8BC53F" : "white",
                                                boxShadow: selectedStatusType === "REJECTED" ? "0 0 0 1px #8BC53F" : "none",
                                            }}
                                        >
                                            {counts?.REJECTED ?? 0}
                                        </span>
                                    </div>
                                </Tabs.Tab>}
                            </Tabs.List>
                        </Tabs>


                        <div style={{ marginBottom: '2rem', marginTop: '1rem' }}>
                            <Grid align="flex-end" gutter="md">
                                {/* Search and Clear row */}
                                <Grid.Col span={{ base: 12, md: 3 }}>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                                        <div style={{ flexGrow: 1 }}>
                                            <Input.Wrapper mt="sm">
                                                <Input
                                                    placeholder="Search"
                                                    value={orderSearch.search}
                                                    onChange={(event) => handleOrderSearch(event.currentTarget.value, "search")}
                                                    rightSectionPointerEvents="all"
                                                    rightSection={<IconSearch />}
                                                />
                                            </Input.Wrapper>
                                        </div>
                                        {isMobile && (<div>
                                            <Button
                                                mt="sm"
                                                variant="light"
                                                color="red"
                                                disabled={!orderSearch.search && !orderSearch.fromDate}
                                                onClick={() => {
                                                    setOrderSearch({
                                                        search: "",
                                                        fromDate: null,
                                                        toDate: new Date()
                                                    });
                                                }}
                                            >
                                                Clear
                                            </Button>
                                        </div>)}
                                    </div>
                                </Grid.Col>

                                {/* From and To Date row */}
                                <Grid.Col span={{ base: 12, md: 6 }}>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                                        <div style={{ flex: 1 }}>
                                            <DateInput
                                                mt="sm"
                                                placeholder="From date"
                                                value={orderSearch.fromDate}
                                                onChange={(value) => handleOrderSearch(value, "fromDate")}
                                                maxDate={orderSearch.toDate}
                                                clearable={true}
                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <DateInput
                                                className="no-class"
                                                mt="sm"
                                                placeholder="To date"
                                                clearable={true}
                                                value={orderSearch.toDate}
                                                onChange={(value) => handleOrderSearch(value, "toDate")}
                                                minDate={orderSearch.fromDate}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                        {!isMobile && (
                                            <div>
                                                <Button
                                                    mt="sm"
                                                    variant="light"
                                                    color="red"
                                                    disabled={!orderSearch.search && !orderSearch.fromDate}
                                                    onClick={() => {
                                                        setOrderSearch({
                                                            search: "",
                                                            fromDate: null,
                                                            toDate: new Date()
                                                        });
                                                    }}
                                                >
                                                    Clear
                                                </Button>
                                            </div>)}
                                    </div>
                                </Grid.Col>
                                {activeTab === "ASN" && selectedStatusType === "PENDING" && selectedAsns.length > 1 && (
                                    <Grid.Col span={{ base: 12, md: 3 }}>
                                        <Button
                                            mt="sm"
                                            style={{ background: "#ab1fa4ff", color: "white" }}
                                            disabled={selectedAsns.length <= 1}
                                            onClick={() => setIsLrModalOpen(true)}
                                        >
                                            LR Entry ({selectedAsns.length})
                                        </Button>
                                    </Grid.Col>
                                )}
                            </Grid>
                        </div>
                        {isMobile ? renderMobileCards() : (
                            <B2BTableGrid
                                columns={columns}
                                data={filteredOrderType}
                                isLoading={isLoading}
                                rowCount={rowCount}
                                pagination={pagination}
                                setPagination={setPagination}
                                fetchOrders={fetchOrders}
                                setOrderSearch={setOrderSearch}
                                orderSearch={orderSearch}
                                onPaginationChange={setPagination}
                            />
                        )}
                    </Tabs.Panel>
                </Tabs>

                <Modal
                    opened={isLrModalOpen}
                    onClose={handleCloseLrModal}
                    title={<h3 style={{ margin: 0, fontWeight: "bold", fontSize: "1.2rem" }}>LR Entry for Selected ASNs ({selectedAsns.join(", ")})</h3>}
                    size="lg"
                    centered
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                        <Grid>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    required
                                    label="Transporter Name / Courier Name"
                                    placeholder="Enter Transporter/Courier Name"
                                    value={lrFormData.transporterName}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, transporterName: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    required
                                    label="LR No / DOC.NO"
                                    placeholder="Enter LR No"
                                    value={lrFormData.logesticReciptNo}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, logesticReciptNo: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <DateInput
                                    required
                                    valueFormat="DD/MM/YYYY"
                                    label="LR Date / Courier Date"
                                    placeholder="Pick a date"
                                    value={lrFormData.lrReceiptDate ? new Date(lrFormData.lrReceiptDate) : null}
                                    onChange={(val) => setLrFormData(prev => ({ ...prev, lrReceiptDate: val ? val.toISOString().split("T")[0] : null }))}
                                />
                            </Grid.Col>
                            {orderType === "WHOLESALE" ? (
                                <Grid.Col span={{ base: 12, md: 6 }}>
                                    <TextInput
                                        label="No Of Carton / Packet Count"
                                        placeholder="Enter Carton / Packet Count"
                                        value={lrFormData.containerNumber}
                                        onChange={(e) => setLrFormData(prev => ({ ...prev, containerNumber: e.target.value }))}
                                    />
                                </Grid.Col>
                            ) : (
                                <Grid.Col span={{ base: 12, md: 6 }}>
                                    <TextInput
                                        required
                                        label="No Of Carton / Packet Count"
                                        placeholder="Enter Carton No"
                                        value={lrFormData.cartonNumber}
                                        onChange={(e) => setLrFormData(prev => ({ ...prev, cartonNumber: e.target.value }))}
                                    />
                                </Grid.Col>
                            )}
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="E-Way Bill No"
                                    placeholder="Enter E-Way Bill No"
                                    value={lrFormData.ewayBillNo}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, ewayBillNo: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="Vehicle No"
                                    placeholder="Enter Vehicle No"
                                    value={lrFormData.vehicleNo}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, vehicleNo: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="Invoice No"
                                    placeholder="Enter Invoice / Document No"
                                    value={lrFormData.documentNo}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, documentNo: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="Tracking Id"
                                    placeholder="Enter Tracking Id"
                                    value={lrFormData.trackingId}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, trackingId: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <TextInput
                                    label="Mobile Number"
                                    placeholder="Enter Mobile No"
                                    value={lrFormData.mobileNo}
                                    onChange={(e) => setLrFormData(prev => ({ ...prev, mobileNo: e.target.value }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <DateInput
                                    valueFormat="DD/MM/YYYY"
                                    label="Delivery Date"
                                    placeholder="Pick a date"
                                    value={lrFormData.deliveryDate ? new Date(lrFormData.deliveryDate) : null}
                                    onChange={(val) => setLrFormData(prev => ({ ...prev, deliveryDate: val ? val.toISOString().split("T")[0] : null }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <DateInput
                                    valueFormat="DD/MM/YYYY"
                                    label="Shipment Date"
                                    placeholder="Pick a date"
                                    value={lrFormData.shipmentDate ? new Date(lrFormData.shipmentDate) : null}
                                    onChange={(val) => setLrFormData(prev => ({ ...prev, shipmentDate: val ? val.toISOString().split("T")[0] : null }))}
                                />
                            </Grid.Col>
                            <Grid.Col span={{ base: 12, md: 6 }}>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <label style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>LR Document</label>
                                    <input
                                        type="file"
                                        accept=".pdf,.jpg,.jpeg,.png"
                                        onChange={(e) => setLrFormData(prev => ({ ...prev, lrDocument: e.target.files[0] }))}
                                    />
                                </div>
                            </Grid.Col>
                        </Grid>
                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "1rem" }}>
                            <Button variant="outline" color="gray" onClick={handleCloseLrModal}>
                                Cancel
                            </Button>
                            <Button
                                color="#8BC53F"
                                disabled={!isLrFormValid}
                                onClick={handleLrSubmit}
                            >
                                Submit LR & Merge
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        </div >
    );
};


export default Approved;




